module.exports = __webpack_public_path__ + "img/logo-oec.7c0d25b4.svg";